<div class="modal-header">
  <h4 class="modal-title" [id]="titleId">{{ 'layout.improvementModal.title' | translate }}</h4>
  <button type="button" class="btn-close" [attr.aria-label]="'layout.improvementModal.close' | translate"
    (click)="close()"></button>
</div>

<div class="modal-body improvement-ranking-modal__body p-0">
  @if (rankingUrl) {
    <!-- clipboard-write: the embedded request form offers to copy the link that tracks a request. -->
    <iframe class="w-100 h-100 border-0 d-block" allow="clipboard-write" [src]="rankingUrl"
      [title]="'layout.improvementModal.title' | translate"></iframe>
  } @else {
    <div class="d-flex h-100 align-items-center justify-content-center">
      <div class="spinner-border text-primary" role="status"></div>
    </div>
  }
</div>
